import useSWR from 'swr';

const useMe = () => {
  const { data, error } = useSWR('monitoring-api/whoami/');

  if (!data) return error;

  return data;
};

export { useMe };
